import { useQuery } from '@tanstack/react-query';
import { getHarvestPlace, getHarvestPlacesRegionStats } from '../api';
import { harvestQueryKeys } from '../constants';
import { HarvestPlacesRegionStatsParams } from '../model';

/** Maskanlar/klasterlar statistikasi. Qaysi kesim kelishi parametrlarga bog'liq:
 *  `regionCode` — viloyat maskanlari, `type=organization` — klasterlar,
 *  unga `taxNumber` qo'shilsa — o'sha klasterning maskanlari.
 *  `plantType` hozircha uzatilmaydi — API'da ixtiyoriy (default COTTON). */
export const useHarvestPlacesRegionStats = (
  params: HarvestPlacesRegionStatsParams,
) => {
  const { year, regionCode, plantType, type, taxNumber } = params;

  return useQuery({
    queryKey: [
      harvestQueryKeys.harvestPlacesRegionStats,
      year,
      regionCode,
      plantType,
      type,
      taxNumber,
    ],
    queryFn: () => getHarvestPlacesRegionStats(params),
    enabled: Boolean(year),
  });
};

/** Maskan details sahifasi uchun. `placeId` — 1-endpointdagi `regions[].id`. */
export const useHarvestPlace = (
  year: string,
  placeId?: string,
  plantType?: string,
) => {
  return useQuery({
    queryKey: [harvestQueryKeys.harvestPlace, year, placeId, plantType],
    queryFn: () => getHarvestPlace(year, placeId as string, plantType),
    enabled: Boolean(year && placeId),
  });
};
